'use strict'

export function formatEmployeeName (employee) {
  let name = ''
  if (employee && employee.fio) {
    name += employee.fio
    if (employee.position) {
      name += ' (' + employee.position + ')'
    }
  }

  return name
}
